import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT } from '../../../../constants';

import { getPartnerIdFromQuery } from '../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import Stepper from '../Stepper';
import { Logo } from '../../../icons/Logo';
import HeadComponent from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import LinkButtonComponent from '../../../button/LinkButtonComponent';

import './ErrorEbonPage.scss';

const ErrorEbonPage = ({ i18n, BRAND_NAME, ebcPartnerId }) => {
    return (
        <div className="template template-primary flex-container-v">
            <div className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                            <Logo />
                        </LocalizedNavLink>
                        <Stepper steps={i18n.STEPS} current={1} />
                    </header>
                </div>
            </div>
            <main role="main" id="p-ebon-error" className="conteneur conteneur-mobile">
                <HeadComponent
                    title={i18n.ERROR.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.EBON_ERROR_PATH}-${ebcPartnerId}`}
                />
                <Stepper steps={i18n.STEPS} current={2} cssClass="mobileDisplay" />
                <div className="error-container">
                    <h1>{i18n.ERROR.TITLE}</h1>

                    <p>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_1)}</p>
                    <div className="reasons">
                        <ul>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_2)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_3)}</li>
                            <li>{convertHtmlToReactDomWithParams(i18n.ERROR.TEXT_4)}</li>
                        </ul>
                    </div>
                    <p>{i18n.ERROR.TEXT_5}</p>
                    <p>{i18n.ERROR.TEXT_6}</p>
                    <br />

                    <LinkButtonComponent
                        to={PATH.HOME_PATH}
                        text={i18n.ERROR.BUTTON_TEXT}
                        color="main"
                    />
                </div>
            </main>
        </div>
    );
};

ErrorEbonPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const ebcPartnerId = getPartnerIdFromQuery(ownProps.match.url);

    return {
        i18n: state.i18n.page.EBON,
        ebcPartnerId: ebcPartnerId
    };
};

export default withRouter(connect(mapStateToProps, null)(ErrorEbonPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/erreur/ErrorEbonPage.js